module.exports = __webpack_public_path__ + "img/Assinatura_Flavio_Andrade.baef0878.png";